import { PeopleMerchantGroupDto } from './people-merchant-group.dto';
import { PeopleQueryBaseDto } from './people-query-base.dto';

export class PeopleContractTypeDto {
  id?: number;
  merchantGroupId?: number;
  merchantGroup?: PeopleMerchantGroupDto;
  name?: string;
  code?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
}

export interface PeopleContractTypeQueryDto extends PeopleQueryBaseDto {
  name?: string;
  merchantGroupId?: number;
  join?: string | string[];
}
